import React from 'react';
import loadable from '@loadable/component';
const SocialActions = loadable(() =>
    import(/* webpackChunkName: "SocialActions" */ '/src/reusable-components/SocialActions'),
);

const TextFooter = (props) => {

    const { data } = props;
    
    let newsSource = '';
    if (data.source) {
        newsSource = data.source.split('/');
        if (newsSource[0] === 'http:' || newsSource[0] === 'https:') {
            newsSource = newsSource[2];
        } else {
            newsSource = newsSource[0];
        }
        newsSource = newsSource.replace('www.', '');
    }

    const copyrightNotice = (
        <>
            &copy; {new Date().getFullYear()} <b>MAGNiTT, Inc.</b> All Rights Reserved
            {data.image_credit && (
                <>
                    <br className="p-0" />
                    <b>Image credit:</b>{' '}{data.image_credit}
                </>
            )}
        </>
    );

    return (
        <>
            <hr/>
            <div className="article-footer">

                {/* specify whether it's a magnitt article or sourced from elsewhere */}
                <p className="article-footnote">
                    {newsSource ? <><b>Source:</b> {newsSource}</> : copyrightNotice}
                </p>

                <SocialActions
                    image={props.image}
                    description={props.description}
                    title={props.title}
                    url={props.url}
                />

            </div>
            <hr />
        </>
    )

}

export default TextFooter;